<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <span class="h5"
                    >RATEIOS -
                    <b-badge variant="warning">{{ operacaoDescr }}</b-badge>
                    <app-btn-voltar
                        class="float-right"
                        v-if="operacao == 'D'"
                    ></app-btn-voltar>
                    <b-button
                        class="float-right"
                        variant="primary"
                        v-if="operacao != 'D'"
                        :disabled="valorDisponivel > 0"
                        @click.stop="confirmarSalvar()"
                        ><i class="fa fa-floppy-o"></i> Salvar</b-button
                    >
                    <b-button
                        class="float-right mr-2"
                        variant="danger"
                        v-if="operacao != 'D'"
                        @click="cancelar()"
                        ><i class="fa fa-times-circle-o"></i> Cancelar</b-button
                    >
                    <btn-inserir-dotacao
                        class="float-right mr-2"
                        :tipo="operacao"
                        v-if="operacao != 'D'"
                        :valorTotal="valorASerRateado"
                        :valorDisponivel="valorDisponivel"
                        @inserirRateio="inserirRateio($event)"
                    ></btn-inserir-dotacao>
                </span>
            </b-card-header>
            <b-card-body>
                <b-alert show>
                    <b-row>
                        <b-col>
                            <h5>
                                CONTRATAÇÃO:
                                <strong
                                    >{{ contratacaoRateios.codContratacao }} -
                                    {{ contratacaoRateios.credenciado }}</strong
                                >
                            </h5>
                        </b-col>
                    </b-row>
                </b-alert>
                <b-row v-if="operacao != 'D'">
                    <b-col>
                        <app-box titulo="Total a ser rateado">{{
                            valorASerRateado | currency
                        }}</app-box>
                    </b-col>
                    <b-col>
                        <app-box
                            titulo="Total rateado"
                            :corBox="corBox"
                            :corTexto="corTexto"
                            >{{ valorRateado | currency }} |
                            {{
                                percentualRateado
                                    | currency({
                                        symbol: '%',
                                        thousandsSeparator: '.',
                                        fractionCount: 2,
                                        fractionSeparator: ',',
                                        symbolPosition: 'back',
                                        symbolSpacing: false
                                    })
                            }}</app-box
                        >
                    </b-col>
                    <b-col>
                        <app-box
                            titulo="Total disponível para ratear"
                            :corBox="corBox"
                            :corTexto="corTexto"
                            >{{ valorDisponivel | currency }}</app-box
                        >
                    </b-col>
                </b-row>
                <div
                    v-if="
                        contratacaoRateios.temConsultoria &&
                        (operacao == 'D' || operacao == 'C')
                    "
                >
                    <h5 class="heading-1">
                        <span
                            >CONSULTORIA -
                            <small
                                >Tipo do rateio:
                                <strong>{{
                                    contratacaoRateios.rateioConsultoriaManual
                                        ? 'MANUAL'
                                        : 'AUTOMÁTICO'
                                }}</strong></small
                            ></span
                        >
                    </h5>
                    <rateios-tabela
                        class="mt-4"
                        :rateios="rateiosConsultoria"
                        :temAcoes="
                            operacao != 'D' ||
                            contratacaoRateios.rateioConsultoriaManual
                        "
                        :valorASerRateado="valorASerRateado"
                        :valorDisponivel="valorDisponivel"
                        :operacao="operacao"
                        @atualizarRateio="atualizarRateio($event)"
                        @excluirRateio="excluirRateio($event)"
                    >
                        <template slot="botoes">
                            <b-button
                                variant="primary"
                                class="mb-2"
                                @click="operacao = 'C'"
                                v-if="mostrarBtnAtualizarRateios"
                                ><i class="fa fa-edit"></i> Atualizar
                                Rateios</b-button
                            >
                        </template>
                    </rateios-tabela>
                </div>
                <div
                    v-if="
                        contratacaoRateios.temInstrutoria &&
                        (operacao == 'D' || operacao == 'I')
                    "
                >
                    <h5 class="heading-1">
                        <span
                            >INSTRUTORIA -
                            <small
                                >Tipo do rateio:
                                <strong>{{
                                    contratacaoRateios.rateioInstrutoriaManual
                                        ? 'MANUAL'
                                        : 'AUTOMÁTICO'
                                }}</strong></small
                            >
                        </span>
                    </h5>
                    <rateios-tabela
                        class="mt-4"
                        :rateios="rateiosInstrutoria"
                        :temAcoes="
                            operacao != 'D' ||
                            contratacaoRateios.rateioInstrutoriaManual
                        "
                        :valorASerRateado="valorASerRateado"
                        :valorDisponivel="valorDisponivel"
                        :operacao="operacao"
                        @atualizarRateio="atualizarRateio($event)"
                        @excluirRateio="excluirRateio($event)"
                    >
                        <template slot="botoes">
                            <b-button
                                variant="primary"
                                class="mb-2"
                                @click="operacao = 'I'"
                                v-if="mostrarBtnAtualizarRateios"
                                ><i class="fa fa-edit"></i> Atualizar
                                Rateios</b-button
                            >
                        </template>
                    </rateios-tabela>
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import RateiosTabela from './RateiosTabela'
import BtnInserirDotacao from './BtnInserirDotacao'

export default {
    components: {
        RateiosTabela,
        BtnInserirDotacao
    },

    props: {
        contratacaoRateios: {
            type: Object,
            default: () => {}
        },

        dotacoesServicos: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            operacao: 'D',
            rateiosConsultoria: [],
            rateiosInstrutoria: []
        }
    },

    methods: {
        cancelar() {
            this.operacao = 'D'
            this.resetarRateios()
        },

        resetarRateios() {
            if (this.contratacaoRateios) {
                this.rateiosConsultoria = JSON.parse(
                    JSON.stringify(this.contratacaoRateios.rateiosConsultoria)
                )
                this.rateiosInstrutoria = JSON.parse(
                    JSON.stringify(this.contratacaoRateios.rateiosInstrutoria)
                )
            }
        },

        inserirRateio(rateio) {
            if (this.operacao == 'C') {
                if (
                    this.rateiosConsultoria.filter((r) => {
                        return (
                            r.codUnidade == rateio.codUnidade &&
                            r.codProjeto == rateio.codProjeto &&
                            r.codAcao == rateio.codAcao
                        )
                    }).length > 0
                ) {
                    this.erroNaInclusaoDotacao()
                } else {
                    rateio.tipo = 0
                    rateio.status = 1
                    rateio.dataAtualizacao = new Date()
                    this.rateiosConsultoria.push(rateio)
                }
            } else if (this.operacao == 'I') {
                if (
                    this.rateiosInstrutoria.filter((r) => {
                        return (
                            r.codUnidade == rateio.codUnidade &&
                            r.codProjeto == rateio.codProjeto &&
                            r.codAcao == rateio.codAcao
                        )
                    }).length > 0
                ) {
                    this.erroNaInclusaoDotacao()
                } else {
                    rateio.tipo = 1
                    rateio.status = 1
                    rateio.dataAtualizacao = new Date()
                    this.rateiosInstrutoria.push(rateio)
                }
            }
        },

        erroNaInclusaoDotacao() {
            this.$swal({
                title: 'Dotação Orçamentária',
                html: `Já existe dotação com a unidade/projeto/ação informados`,
                icon: 'error'
            })
        },

        atualizarRateio(rateio) {
            if (this.operacao == 'C') {
                for (
                    let index = 0;
                    index < this.rateiosConsultoria.length;
                    index++
                ) {
                    const rateioAtual = this.rateiosConsultoria[index]
                    if (
                        rateioAtual.codUnidade == rateio.codUnidade &&
                        rateioAtual.codProjeto == rateio.codProjeto &&
                        rateioAtual.codAcao == rateio.codAcao
                    ) {
                        this.rateiosConsultoria[index].valor = rateio.valor
                        this.rateiosConsultoria[index].percentual =
                            rateio.percentual
                        this.rateiosConsultoria[index].justificativa =
                            rateio.justificativa
                        this.rateiosConsultoria[index].dataAtualizacao =
                            new Date()
                        break
                    }
                }
            } else if (this.operacao == 'I') {
                for (
                    let index = 0;
                    index < this.rateiosInstrutoria.length;
                    index++
                ) {
                    const rateioAtual = this.rateiosInstrutoria[index]
                    if (
                        rateioAtual.codUnidade == rateio.codUnidade &&
                        rateioAtual.codProjeto == rateio.codProjeto &&
                        rateioAtual.codAcao == rateio.codAcao
                    ) {
                        this.rateiosInstrutoria[index].valor = rateio.valor
                        this.rateiosInstrutoria[index].percentual =
                            rateio.percentual
                        this.rateiosInstrutoria[index].justificativa =
                            rateio.justificativa
                        this.rateiosInstrutoria[index].dataAtualizacao =
                            new Date()
                        break
                    }
                }
            }
        },

        excluirRateio(rateio) {
            if (this.operacao == 'C') {
                for (
                    let index = 0;
                    index < this.rateiosConsultoria.length;
                    index++
                ) {
                    const rateioAtual = this.rateiosConsultoria[index]
                    if (
                        rateioAtual.codUnidade == rateio.codUnidade &&
                        rateioAtual.codProjeto == rateio.codProjeto &&
                        rateioAtual.codAcao == rateio.codAcao
                    ) {
                        this.rateiosConsultoria.splice(index, 1)
                        break
                    }
                }
            } else if (this.operacao == 'I') {
                for (
                    let index = 0;
                    index < this.rateiosInstrutoria.length;
                    index++
                ) {
                    const rateioAtual = this.rateiosInstrutoria[index]
                    if (
                        rateioAtual.codUnidade == rateio.codUnidade &&
                        rateioAtual.codProjeto == rateio.codProjeto &&
                        rateioAtual.codAcao == rateio.codAcao
                    ) {
                        this.rateiosInstrutoria.splice(index, 1)
                        break
                    }
                }
            }
        },

        confirmarSalvar() {
            this.$swal({
                title: 'Rateios',
                html: `Confirma as alterações no rateio da ${
                    this.operacao == 'C' ? 'consultoria' : 'instrutoria'
                }?
                <br/><br/><div class="alert alert-danger" role="alert">
                <div class="row">
                            <div class="col-3">
                                <i class="fa fa-exclamation-circle fa-5x"></i>
                            </div>
                            <div class="col-9">
                                <h4>Ao confirmar a alteração no rateio modificações realizadas no SGF 
                                não serão refletidas no Espaço do Fornecedor</h4>
                            </div>
                        </div>
		             </div>`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.salvarRateios()
                }
            })
        },

        salvarRateios() {
            this.$store.dispatch('addRequest')
            let contratacaoRateios = {
                codContratacao: this.contratacaoRateios.codContratacao,
                tipo: this.operacao == 'C' ? 0 : 1,
                rateios:
                    this.operacao == 'C'
                        ? this.rateiosConsultoria
                        : this.rateiosInstrutoria
            }
            this.dotacoesServicos
                .salvarRateios(contratacaoRateios)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Rateios atualizados com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit(
                                'atualizarContratacaoRateios',
                                response.data
                            )
                            this.operacao = 'D'
                        } else {
                            this.$toast.error(
                                'Falha ao atualizar rateios!',
                                'ERRO',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        operacaoDescr() {
            switch (this.operacao) {
                case 'D':
                    return 'DETALHAR'
                case 'C':
                    return 'ATUALIZAR RATEIOS CONSULTORIA'
                case 'I':
                    return 'ATUALIZAR RATEIOS INSTRUTORIA'
                default:
                    return 'INDEFINIDO'
            }
        },

        valorASerRateado() {
            if (this.operacao == 'C') {
                return this.contratacaoRateios.valorTotalConsultoria
            } else {
                return this.contratacaoRateios.valorTotalInstrutoria
            }
        },

        valorRateado() {
            if (this.operacao == 'C') {
                return Number.parseFloat(
                    this.rateiosConsultoria
                        .map((item) => {
                            return item.valor
                        })
                        .reduce((a, b) => a + b, 0)
                        .toFixed(2)
                )
            } else {
                return Number.parseFloat(
                    this.rateiosInstrutoria
                        .map((item) => {
                            return item.valor
                        })
                        .reduce((a, b) => a + b, 0)
                        .toFixed(2)
                )
            }
        },

        valorDisponivel() {
            return Number.parseFloat(
                (this.valorASerRateado - this.valorRateado).toFixed(2)
            )
        },

        percentualRateado() {
            return (this.valorRateado / this.valorASerRateado) * 100
        },

        corTexto() {
            return this.percentualRateado < 100 ? 'danger' : 'primary'
        },

        corBox() {
            return this.percentualRateado < 100 ? 'danger' : 'primary'
        },

        mostrarBtnAtualizarRateios() {
            return (
                this.operacao == 'D' &&
                this.$temAcessoView('CRED-UABS-RAT-01') &&
                this.contratacaoRateios.status != 13 &&
                this.contratacaoRateios.status != 14 &&
                this.contratacaoRateios.status != 16 &&
                this.contratacaoRateios.status != 17
            )
        }
    },

    watch: {
        contratacaoRateios() {
            this.resetarRateios()
        }
    }
}
</script>
